import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/agroLayoutReducer';
import DiscreteTabs from 'components/DesignSystem/Tabs/DiscreteTabs';
import { Outlet } from 'react-router-dom';

export default function WaterBalanceSequential() {
  useEffect(() => {
    store.dispatch(setCurrentTab('water-balance-sequential'));
  }, []);

  return (
    <div className="px-0 pt-0 px-lg-5 pt-lg-4">
      <DiscreteTabs type="round" activeKey="./">
        <DiscreteTabs.Tab
          path="/agro/water-balance-sequential/"
          title="Mapas"
        />
        <DiscreteTabs.Tab
          path="/agro/water-balance-sequential/detailed-view"
          title="Visão detalhada"
        />
      </DiscreteTabs>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
}
